// extracted by mini-css-extract-plugin
export default {"cards":"card-list_cards__zDjbG"};